import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  return (
    <div className="min-h-screen bg-[#0A0B10] text-[#F8FAFC]">
      <Sidebar />
      <main className="pl-64 min-h-screen">
        <div className="px-6 sm:px-8 py-6 fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
